import { interactiveText } from "@/ui/utils.css";
import type { JSX } from "react";

export function InlineButton(props: Omit<JSX.IntrinsicElements["button"], "className" | "type">) {
  return <button {...props} className={interactiveText} type="button" />;
}
